import React from "react";
import Dropdown from "./Dropdown";
import SearchInput from "./SearchInput";
import useModal from "../modal/useModal";
import Modal from "../modal/Modal";
import { useState, useEffect, createContext, useMemo, useCallback } from "react";
import avatar from "../../assets/images/mp.png";
import searchIcon from "../../assets/images/searchbtn.png"
import FullScreen from "../MainContent/FullScreen";
import severUrl from "../../api";
import axios from "axios";
import MyWindowPortal, { useWindowPortalContext } from "./WindowPortalHook";
import * as ReactDOM from 'react-dom';


const NavItemStyle = {
  display: "inline-block",
  textAlign: "center",
  color: "white",
  textDecoration: "none",
  fontWeight: "400"
};


// Safari 3.0+ "[object HTMLElementConstructor]"
var isSafari = window.safari !== undefined;

function Expanded(props) {

  const { close } = useWindowPortalContext();

  return (
    <div>
      <p align="center">{props.title}</p>
      <button type="button" onClick={close}>
        close me
      </button>
    </div>
  );
}


export const NavBarDesktopV1 = (props) => {

  const { isShowing, toggle, showIndex } = useModal();
  const [user, setUser] = useState(null);
  const [searchShow, setSearchShow] = useState(false);
  const [showFull, setShowFull] = useState(false);
  const [keySearch, setKeySearch] = useState('');
  const [search_list, set_search_list] = useState([]);
  const [click, setClick] = useState(false);

  const handleClick  = (tab) => { 
    // setClick(!click);
    localStorage.setItem('activeTab', tab);
  }
  useEffect(() => {
    const user = localStorage.getItem("user", false);
    if (user && user !== "undefined") {
      setUser(JSON.parse(user));
    }
  }, []);

  const changeSearchShow = () => {
    setSearchShow(!searchShow)
    // localStorage.setItem("key", props.key);
    // var bodyFormData = new FormData();
    // bodyFormData.append("key", props.key);
    // axios
    //   .post(severUrl + "blog/search", bodyFormData)
    //   .then((response) => response.data)
    //   .then((data) => {

    //     set_search_list(JSON.stringify(data))
    //     console.log(data)

    //   }).catch((e) => {
    //     // oh no, the fetch failed! We should do something about it!
    //   });

    setShowFull(!showFull)
    if (!searchShow)
    {
      localStorage.removeItem("keySearch");
      localStorage.removeItem("search_list");
      console.log('removed')
    }
  }

  const triggerHandler = (inputKey) => {
    console.log(inputKey)
    // setShowFull(!showFull)
    setKeySearch(inputKey)

    var bodyFormData = new FormData();
    bodyFormData.append("key", inputKey);
    
    axios
      .post(severUrl + "blog/search", bodyFormData)
      .then((response) => response.data)
      .then((data) => {

        set_search_list(data.post)

        // console.log(data.post)

      }).catch((e) => {
        // oh no, the fetch failed! We should do something about it!
      });
  }

  // const [data, setData] = useState([
  //   { id: 0, title: "First element", isOpen: false },
  //   { id: 1, title: "Second element", isOpen: false },
  //   { id: 2, title: "Third element", isOpen: false },
  //   { id: 4, title: "Forth element", isOpen: false }
  // ]);

  // const openWindow = useCallback((id) => {
  //   setData((prevState) =>
  //     prevState.map((item) =>
  //       item.id === id ? { ...item, isOpen: true } : item
  //     )
  //   );
  // }, []);

  // const expanded = data.filter((item) => item.isOpen);

  // const closeWindow = useCallback((id) => {
  //   setData((prevState) =>
  //     prevState.map((item) =>
  //       item.id === id ? { ...item, isOpen: false } : item
  //     )
  //   );
  // }, []);

  // const expandedWindows = useMemo(() => {
  //   return expanded.map((item) => (
  //     <MyWindowPortal
  //       title={item.title}
  //       key={item.id}
  //       id={item.id}
  //       close={closeWindow}
  //     >
  //       {/* <StylesProvider injectFirst> */}
  //         <Expanded title={item.title} id={item.id} />
  //       {/* </StylesProvider> */}
  //     </MyWindowPortal>
  //   ));
  // }, [expanded, closeWindow]);

  // const closeAllWindow = () => {
  //   setData((ptevState) =>
  //     ptevState.map((item) => ({ ...item, isOpen: false }))
  //   );
  // };

  // useEffect(() => {
  //   window.addEventListener("beforeunload", closeAllWindow);
  //   return () => {
  //     window.removeEventListener("beforeunload", closeAllWindow);
  //   };
  // }, []);

  return (
    <>
      <Modal isShowing={isShowing} hide={toggle} activeTab={showIndex} />

      {showFull && <FullScreen keyword={keySearch} results={search_list} />}
      {/* <div id="useless"></div>

      {showFull && ReactDOM.render(
        <FullScreen  key={keySearch} />,
        document.querySelector("#useless")
      )} */}


      {/* <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <th>{item.id}</th>
              <th>{item.title}</th>
              <th>{item.isOpen.toString()}</th>
              <th>
                <button
                  onClick={
                    !item.isOpen
                      ? openWindow.bind(null, item.id)
                      : closeWindow.bind(null, item.id)
                  }
                >
                  {!item.isOpen ? "Open" : "Close"}
                </button>
              </th>
            </tr>
          ))}
        </tbody> */}

      {/* {expandedWindows} */}

      <nav
        style={{
          borderBottom: "solid 1px",
          backgroundColor: "rgb(2,0,36)",
          justifyContent: "space-around",
          alignItems: "center",
          display: "flex",
          border: 0,
          padding: 0,
          height: "40px",
          position: "fixed",
          width: "100%",
          zIndex: "10"
        }}
      >
        {searchShow && <SearchInput triggerHandler={triggerHandler} showHandler={changeSearchShow} />}

        <div className="my-nav"
          style={{
            borderBottom: "solid 1px",
            backgroundColor: "rgb(2,0,36)",
            justifyContent: "space-between",
            alignItems: "center",
            display: !searchShow ? "flex" : "none",
            border: 0,
            padding: 0,
            height: "40px",
            position: "fixed",
            width: "100%",
            zIndex: "10"
          }}
        >
          <a className="nav-cus-item" href="/home"><img src={avatar} style={{ maxWidth: "20px", width: "100%" }} /></a>
          <a className="nav-cus-item" href='/home' style={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>ML Practices</a>
          <a className="nav-cus-item" href="/about" style={NavItemStyle}>
            About
          </a>
          <Dropdown />
          {/* <a className="nav-cus-item" href="/update" style={NavItemStyle}>
            Updates
          </a> */}
           <a className="nav-cus-item" href="/support" style={NavItemStyle}>
            Support
          </a>
          <a className="nav-cus-item" href="/service" style={NavItemStyle}>
            Offer me
          </a>
           <div className="nav-icon" onClick={handleClick}>
            <a className="nav-cus-item-active" href="/tictac" style={NavItemStyle}>
              Tictac 
            </a>
          </div>
          <a className="nav-cus-item" style={{ backgroundColor: "transparent", margin: "0", padding: "0" }}>
            <button onClick={changeSearchShow} style={{ backgroundColor: "transparent", margin: "0", padding: "0", border: "none" }}><img style={{ maxWidth: "20px" }} src={searchIcon} /></button></a>
          <div
            style={{
              alignItems: "end",
              justifyContent: "end",
              alignContent: "end",
              justifyItems: "end",
              display: "grid",
              gridAutoRows: "auto",
              // width: "100%",
              textAlign: "right",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                backgroundColor: "none",
              }}
            >
              {!user && (
                <>
                  <button
                    style={{
                      border: "none",
                      fontWeight: "bold",
                      color: "white",
                      backgroundColor: "transparent",
                      paddingRight: "2px",
                      fontSize: "14px"
                    }}
                    onClick={() => toggle("Login")}
                  >
                    Login |
                  </button>
                  <button
                    style={{
                      border: "none",
                      fontWeight: "bold",
                      color: "white",
                      backgroundColor: "transparent",
                      paddingLeft: "0",
                      fontSize: "14px"
                    }}
                    onClick={() => toggle("SignUp")}
                  >
                    SignUp
                  </button>
                </>
              )}
              {user && (
                <>
                  <a
                    href="/account"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "fit-content",
                      color: "white"
                    }}
                  >
                    <div className="nav-cus-item">Xin chào</div>
                    <div
                      style={{
                        fontWeight: "bold",
                        marginLeft: "5px",
                        fontSize: "14px"
                      }}
                    >
                      {user.username}
                    </div>
                  </a>
                </>
              )}
            </div>
          </div>  </div>
      </nav>
    </>
  )
};

